export default __webpack_public_path__ + "static/media/900.f73e9d02.jpg";